var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"ui-icon",style:({
        '--ui-icon-color': _setup.props.color,
        '--ui-icon-size': _setup.props.size,
    }),attrs:{"aria-hidden":"true"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }